import { Stack } from "@mui/material";
import { TextSkeleton } from "@src/appV2/redesign/system/ui-components";
import { type ReactElement } from "react";

export function DocumentDetailsSectionSkeleton(): ReactElement {
  return (
    <Stack spacing={3}>
      <TextSkeleton variant="body1" width="30%" />

      <TextSkeleton variant="body2" width="100%" />
      <TextSkeleton variant="body2" width="100%" />
      <TextSkeleton variant="body2" width="30%" />
    </Stack>
  );
}
